import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &:hover{\n    svg {\n      fill: ",
        ";\n    }\n  }\n  &:nth-child(2){\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100px;\n  margin-top: -12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { darkColors } from "../../../theme";
import Flex from "../../Box/Flex";
import Link from "../../Link/Link";
import Logo from "../../../widgets/Menu/components/Logo";
import { socials } from "../config";
var StyledLink = styled(Link).withConfig({
    componentId: "sc-a364da25-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var StyledLogoContainer = styled.div.withConfig({
    componentId: "sc-a364da25-1"
})(_templateObject1());
var SocialLinks = function(_param) /*#__PURE__*/ {
    var props = _extends({}, _param);
    return _jsxs(Flex, _object_spread_props(_object_spread({}, props), {
        style: {
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                children: socials.map(function(social, index) {
                    var iconProps = {
                        width: "20px",
                        color: darkColors.textSubtle,
                        style: {
                            cursor: "pointer"
                        }
                    };
                    var Icon = social.icon;
                    var mr = index < socials.length - 1 ? "24px" : 0;
                    /* No items have .items (this is a submenu)
      if (social.items) {
        return (
          <Dropdown key={social.label} position="top" target={<Icon {...iconProps} mr={mr} />}>
            {social.items.map((item) => (
              <StyledLink external key={item.label} href={item.href} aria-label={item.label} >
                {item.label}
              </StyledLink>
            ))}
          </Dropdown>
        );
      } */ return /*#__PURE__*/ _jsx(StyledLink, {
                        external: true,
                        href: social.href,
                        "aria-label": social.label,
                        mr: mr,
                        children: /*#__PURE__*/ _jsx(Icon, _object_spread({}, iconProps))
                    }, social.label);
                })
            }),
            /*#__PURE__*/ _jsx(Flex, {
                children: /*#__PURE__*/ _jsx(StyledLogoContainer, {
                    children: /*#__PURE__*/ _jsx(Logo, {
                        isDark: true,
                        href: "/"
                    })
                })
            })
        ]
    }));
};
export default SocialLinks;
